import React from 'react';

import Box from '@mui/material/Box';
import type { Variant } from '@mui/material/styles/createTypography';

import Typography from 'src/components/ui/Typography';
import type { Props as IconProps } from 'src/components/ui/Icon';
import Icon from 'src/components/ui/Icon';
import { styledComponent } from 'src/utils/styled';

const Text = styledComponent(Typography)<{ $maxWidth: string }>`
    max-width: ${({ $maxWidth }) => $maxWidth};
    margin-top: 1rem;
`;

export interface Props {
    icon: IconProps['name'];
    text1: string;
    text2?: string;
    variant1?: Variant;
    variant2?: Variant;
    maxWidth?: string;
    iconSize?: string;
}

const EmptyState: React.FC<Props> = ({
    icon,
    text1,
    text2,
    variant1 = 'subtitle1',
    variant2 = 'subtitle1',
    maxWidth = '13.375rem',
    iconSize = '6rem',
}) => (
    <Box display="flex" flexDirection="column" width="100%" alignItems="center" data-target-id="empty-state">
        <Icon size={iconSize} name={icon} />
        <Box mt="-1.5rem">
            <Icon size={iconSize} name="Ellipse" />
        </Box>
        <Box mt={`calc(${iconSize} / -2)`}>
            <Text
                $maxWidth={maxWidth}
                variant={variant1}
                color="textSecondary"
                align="center"
                dangerouslySetInnerHTML={{
                    __html: text1,
                }}
            />
            {text2 && (
                <Text
                    $maxWidth={maxWidth}
                    variant={variant2}
                    color="textSecondary"
                    align="center"
                    dangerouslySetInnerHTML={{
                        __html: text2,
                    }}
                />
            )}
        </Box>
    </Box>
);

export default EmptyState;
